let externalRecipients = [];
let attachments = null;
let original_attachments = null;
let original_recipients = null;


// Debug logging function
function logDebug(message) {
  // const debugDiv = document.getElementById("debug-log");
  // if (debugDiv) {
  //   debugDiv.innerHTML += `<p>${message}</p>`;
  // }
  console.log(message);
}

function displayWebAddInVersion(version, build) {
  const span = document.getElementById("version-info");
  if (span) {
    span.innerHTML = `<strong>${version}</strong> Build: ${build}`;
  }
}

// Display message
function displayMessage(message) {
  const errorDiv = document.getElementById("error-messages");
  errorDiv.innerHTML = '';  
  const messageDiv = document.getElementById("message-div");
  if (messageDiv) {
    messageDiv.innerHTML = `<p>${message}</p>`;
  }
  console.log(message);
}

Office.onReady(async (info) => {
  try {
    var platform = Office.context.diagnostics.platform;
    logDebug(`Office.onReady executed. Host: ${info.host}, Platform: ${info.platform}`);    
    const {version, build} = getWebAddInVersionInfo();
    displayWebAddInVersion(version, build);

    if (info.host === Office.HostType.Outlook && info.platform == Office.PlatformType.PC) {      
      document.getElementById("old_outlook_ui").style.display = "flex";
      document.getElementById("new_outlook_ui").style.display = "none";
      return;    
    } else {
      document.getElementById("old_outlook_ui").style.display = "none";

      const isValidationEnabled = await loadAddInValidationStatus();  
      if (isValidationEnabled === "false") {
        document.getElementById("no_validation_ui").style.display = "flex";
        document.getElementById("new_outlook_ui").style.display = "none";
        return;    
      } else {
        document.getElementById("no_validation_ui").style.display = "none";
      }

      var userName = "";
      var userEmail = "";
      if(info.host === Office.HostType.Outlook) {
        userName = Office.context.mailbox.userProfile.displayName;
        userEmail = Office.context.mailbox.userProfile.emailAddress;
      }
      appInsights.setAuthenticatedUserContext(userEmail);
      appInsights.trackEvent({
        name: 'Add-In Initialized',
        properties: {
          host: getHostName(),
          platform: getPlatformName(),
          addInVersion: version + " " + build
        }
      });
      appInsights.trackPageView({name: 'Task Pane'});
      console.log('Application Insights initialized successfully');
    }

  } catch(error) {
    console.error('Application Insights initialization failed:', error);

    if(appInsights) {
      appInsights.trackException({exception: error});
    }
  }


  // Verify Office context
  if (!Office.context) {
    logDebug("Error: Office.context is not available.");
    if(appInsights) {
      appInsights.trackException({exception: "Office.context is not available."});
    }    
    return;
  }

  if (Office.context.mailbox.item.itemType === "message") {
    loadEmailValidationData();
    document.addEventListener('change', function(event) {
        if (event.target.type === 'checkbox') {
          validateWithSessionData();
        }
    });  
  } else if (Office.context.mailbox.item.itemType === "appointment") {
    loadAppointmentValidationData();
    document.addEventListener('change', function(event) {
        if (event.target.type === 'checkbox') {
          validateWithSessionData();
        }
    });     
  }


}).catch((error) => {
  logDebug(`Error in Office.onReady: ${error.message}`);
  if(appInsights) {
    appInsights.trackException({exception: error});
  }  
});

async function validateWithSessionData() {  
  let validationError = null;
  const item = Office.context.mailbox.item;  
  const selectedRecipients = Array.from(
    document.querySelectorAll("#recipients-list input:checked")
  ).map((input) => input.value);
  const selectedAttachments = Array.from(
    document.querySelectorAll("#attachments-list input:checked")
  ).map((input) => input.value);

  displayMessage('Please hold on for a moment while we save your confirmation.');
  if (
    selectedRecipients.length !== externalRecipients.length
    || selectedAttachments.length !== original_attachments.length
  ) {
    Office.context.mailbox.item.sessionData.setAsync(
      "X-SendProtect-State",
      JSON.stringify({recipients: "", attachments: ""}),
      (asyncResult) => {
        if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
          console.log("Saving Session Data Succeeded");
          validationError = 'Please confirm by selecting each checkbox to send outside EY';
          displayValidationErrors(validationError);
        } else {
          displayValidationErrors("There was an error saving your confirmation. Please try again.");
          logDebug(asyncResult.error);
          console.error("Failed to save Session Data:", asyncResult.error);
          if(appInsights) {
            appInsights.trackException({exception: asyncResult.error});
          }              
        }
      }
    );
  } else {
    Office.context.mailbox.item.sessionData.setAsync(
      "X-SendProtect-State",
      JSON.stringify({recipients: selectedRecipients.join(";"), attachments: selectedAttachments.join(";")}),      
      (asyncResult) => {
        if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
          displayMessage('You are now approved to Send your email.');                             
        } else {
          displayValidationErrors("There was an error saving your confirmation. Please try again.");
          logDebug(asyncResult.error);
          console.error("Failed to save Session Data:", asyncResult.error);
          if(appInsights) {
            appInsights.trackException({exception: asyncResult.error});
          }              
        }
      }
    );
  }
}

async function loadEmailValidationData() {
  externalRecipients = []; // Reset external recipients list
  const item = Office.context.mailbox.item;

  const internalDomains = await loadInternalDomains();

  // Get all recipients (To, Cc, Bcc)
  const recipientTypes = ["to", "cc", "bcc"];
  let recipientPromises = recipientTypes.map(type =>
    new Promise((resolve, reject) => {
      item[type].getAsync((asyncResult) => {
        if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
          resolve(asyncResult.value);
        } else {
          reject(asyncResult.error);
        }
      });
    })
  );

  Promise.all(recipientPromises)
    .then((results) => {
      const allRecipients = results.flat();
      original_recipients = allRecipients;
      checkValidationData(allRecipients, internalDomains);
    })
    .catch((error) => {
      console.error("Error fetching recipients:", error);
      if(appInsights) {
        appInsights.trackException({exception: error});
      }              
    });
}

async function loadAppointmentValidationData() {
  externalRecipients = []; // Reset external recipients list
  const internalDomains = await loadInternalDomains();

  //Get required attendees
  Office.context.mailbox.item.requiredAttendees.getAsync(function (asyncResult) {

    if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
      //Add to our total of required attendees and ensure that the current user isn't processed as an attendee
      var apptRequiredAttendees = asyncResult.value;

      //Get attendees except for the current user (which is only included in this array on Outlook on Windows, not on Outlook on the web.)
      var apptRequiredAttendeesWithoutUser = apptRequiredAttendees.filter(function(attendee){return attendee.emailAddress !== Office.context.mailbox.userProfile.emailAddress;});

      //Get optional attendees
      Office.context.mailbox.item.optionalAttendees.getAsync(function (asyncResult2) {
        if (asyncResult2.status === Office.AsyncResultStatus.Succeeded) {
          //Add to our total of optional attendees and ensure that the current user isn't processed as an attendee
          var apptOptionalAttendees = asyncResult2.value;          
          //Get attendees except for the current user (which is only included in this array on Outlook on Windows, not on Outlook on the web.)
          var apptOptionalAttendeesWithoutUser = [];
          if(apptOptionalAttendees !== undefined) {
            apptOptionalAttendeesWithoutUser = apptOptionalAttendees.filter(function(attendee){return attendee.emailAddress !== Office.context.mailbox.userProfile.emailAddress;});
          }
        } else {
          console.error(`onAppointmentAttendeesChangedHandler(): Error with item.optionalAttendees.getAsync(): ${asyncResult2.error}`);
          if(appInsights) {
            appInsights.trackException({exception: asyncResult2.error});
          }             
        }

        console.log(apptRequiredAttendeesWithoutUser);
        console.log(apptOptionalAttendeesWithoutUser);

        var allAttendees = [];
        if (apptRequiredAttendeesWithoutUser!== undefined && apptOptionalAttendeesWithoutUser !== undefined 
          && apptRequiredAttendeesWithoutUser.length>0 && apptOptionalAttendeesWithoutUser.length>0) {
          allAttendees = [...apptRequiredAttendeesWithoutUser,...apptOptionalAttendeesWithoutUser];  
        } else if (apptRequiredAttendeesWithoutUser.length>0) {
          allAttendees = apptRequiredAttendeesWithoutUser;
        } else if (apptOptionalAttendeesWithoutUser.length>0) {
          allAttendees = apptOptionalAttendeesWithoutUser;          
        }
        
        checkValidationData(allAttendees, internalDomains);

      });
    } else {
      console.error(`onAppointmentAttendeesChangedHandler(): Error with item.requiredAttendees.getAsync(): ${asyncResult.error}`);
      if(appInsights) {
        appInsights.trackException({exception: asyncResult.error});
      }                   
    }
  });

}

function checkValidationData(allRecipients, internalDomains) {

  externalRecipients = validateExternalRecipients(allRecipients, internalDomains);

  let emailError = null;
  if (externalRecipients.length > 0) {
    emailError = `Invalid recipients: ${externalRecipients
      .map((r) => r)
      .join(", ")}. Only ey.com addresses are allowed.`;

    // Load attachments
    Office.context.mailbox.item.getAttachmentsAsync((asyncResult) => {
      if (asyncResult.status === Office.AsyncResultStatus.Failed) {
        console.log(`Error getting attachments: ${asyncResult.error.message}`);
        if(appInsights) {
          appInsights.trackException({exception: asyncResult.error});
        }                           
        return;
      }

      var all_attachments = asyncResult.value;
      original_attachments = all_attachments.filter(function(attachment) {
        return !attachment.isInline; //Exclude inline images (body/signature)
      });      
      
      let attachmentError = null;
      if (original_attachments.length === 0) {
        attachmentError = "No attachments found. At least one attachment is required.";
      }

      if (emailError || attachmentError) {
        console.log("Validation errors found, displaying form.");

        const attachments = original_attachments;
        displayValidationData({
          emailError,
          attachmentError,
          externalRecipients,
          attachments,
        });
    
      }
    
    });          
  }  
}

// Function to display validation data (called from functions.js)
function displayValidationData(data) {
  populateRecipients(data.externalRecipients);
  populateAttachments(data.attachments);
}

// Display validation errors
function displayValidationErrors(emailError) {
  const messageDiv = document.getElementById("message-div");
  messageDiv.innerHTML = '';  
  const errorDiv = document.getElementById("error-messages");
  errorDiv.innerHTML = '';

  const p = document.createElement("p");
  p.textContent = emailError;
  p.style.color = "red";
  errorDiv.appendChild(p);

}

// Populate recipients list with checkboxes
function populateRecipients(recipients) {
  const list = document.getElementById("recipients-list");
  list.innerHTML = '';
  recipients.forEach((recipient) => {
    const div = document.createElement("div");
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.value = recipient;
    checkbox.checked = false;
    const label = document.createElement("span");
    label.textContent = recipient;
    div.appendChild(checkbox);
    div.appendChild(label);
    list.appendChild(div);
  });
}

// Populate attachments list with checkboxes
function populateAttachments(attachments) {
  const list = document.getElementById("attachments-list");
  list.innerHTML = '';
  attachments.forEach((attachment) => {
    const div = document.createElement("div");
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.value = attachment.id;
    checkbox.checked = false;
    const label = document.createElement("span");
    label.textContent = attachment.name;
    div.appendChild(checkbox);
    div.appendChild(label);
    list.appendChild(div);
  });
}

